import React from 'react';
import dayjs from 'dayjs';
import { T } from 'lib/tolgee';
export default function LiveStateTime({
  live
}) {
  if (!live) {
    return null;
  }
  if (!live?.startTime && !live?.endTime && !live.scheduledTime) {
    return <T keyName="VideoContent-liveComingSoon">Live coming soon</T>;
  }
  return <T keyName="VideoContent-liveState" parameters={{
    live: live?.state,
    date: dayjs(live?.startTime).from(dayjs())
  }}>
      {'{live, select, finished {Streamed} other {Started streaming}} {date}'}
    </T>;
}